import {
  Box,
  BoxContent,
  Button,
  Columns,
  ColumnsItem,
  Container,
  Headline,
  HeadlineLevel,
  RowItem,
  Rows,
  Text,
  TextLevels,
  Title,
  TitleLevels,
  TypographyAlign,
  TypographyColor,
  TypographyTransform,
} from '@bytel/trilogy-react-ts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { unitCO2eq, unitData } from '@shared/constants';
import useHomeData from '@domain/home/hook';
import useData from './hook';
import ButtonNavigation from '../../../shared/components/button-navigation';
import './style.css';
import { BilanCarboneProps } from './type';

const BoxBilanCarbone: React.FC<BilanCarboneProps> = ({ data }) => {
  const { last } = useData(data);
  const { buttonNeutraliteCarbone } = useHomeData();

  const { t } = useTranslation('domain/home', {
    keyPrefix: 'consommationFlotte',
  });

  return (
    <Box className="is-fullwidth is-fullheight" data-cy="home-boxBilanCarbone">
      <BoxContent className="homeBoxBilanCarbone">
        <Rows>
          <RowItem>
            <Title level={TitleLevels.THREE} className="is-marginless" data-cy="boxBilanCarbone-bilan">
              {t('bilan')}
            </Title>
            <Text level={TextLevels.THREE} typo={TypographyTransform.TEXT_ITALIC} data-cy="boxBilanCarbone-flotte">
              <br />
              {t('infoConso')}
            </Text>
          </RowItem>
          <RowItem>
            <Columns className="is-flex is-aligned-center">
              <ColumnsItem size={12} className="is-fullwidth is-flex is-justified-center">
                <Container fluid data-cy="boxBilanCarbone-container">
                  <Columns className="is-justified-center">
                    <ColumnsItem size={5} className="is-flex">
                      <Rows>
                        <RowItem>
                          <Text
                            level={TextLevels.TWO}
                            typo={TypographyAlign.TEXT_CENTERED}
                            data-cy="boxBilanCarbone-consommation"
                          >
                            {t('consommation')}
                          </Text>
                        </RowItem>
                        <RowItem>
                          <Text className="is-aligned-center" level={TextLevels.ONE} style={{ whiteSpace: 'nowrap' }}>
                            <Title
                              markup="span"
                              className="is-primary carbonValueNumber"
                              level={TitleLevels.THREE}
                              data-cy="boxBilanCarbone-valeurFlotteConso"
                            >
                              {last?.data.value ?? 0}
                            </Title>{' '}
                            {last?.data.unit ?? unitData[0]}
                          </Text>
                        </RowItem>
                        <RowItem>
                          <Text
                            level={TextLevels.TWO}
                            typo={TypographyAlign.TEXT_CENTERED}
                            data-cy="boxBilanCarbone-internet"
                          >
                            {t('internet')}
                          </Text>
                        </RowItem>
                      </Rows>
                    </ColumnsItem>
                    <ColumnsItem
                      size={2}
                      className="is-unselectable is-flex is-paddingless is-aligned-center is-justified-center "
                      verticalCenter
                    >
                      <div className="has-text-secondary is-flex is-justified-center">
                        <Headline typo={TypographyColor.TEXT_PRIMARY} level={HeadlineLevel.LEVEL2}>
                          =
                        </Headline>
                      </div>
                    </ColumnsItem>
                    <ColumnsItem className="is-flex-1" size={5}>
                      <Rows>
                        <RowItem>
                          <Text
                            level={TextLevels.TWO}
                            typo={TypographyAlign.TEXT_CENTERED}
                            data-cy="boxBilanCarbone-equivalent"
                          >
                            {t('equivalent')}
                          </Text>
                        </RowItem>
                        <RowItem />
                        <RowItem>
                          <Text
                            className="has-text-secondary has-text-centered"
                            data-cy="boxBilanCarbone-valeurCarbone"
                            level={TextLevels.ONE}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            <Title
                              markup="span"
                              className="is-primary carbonValueNumber"
                              level={TitleLevels.THREE}
                              data-cy="boxBilanCarbone-equivalent"
                            >
                              {last?.co2eq.value ?? 0}
                            </Title>{' '}
                            {last?.co2eq.unit ?? unitCO2eq[0]}
                            <sub>2</sub>
                          </Text>
                        </RowItem>
                        <RowItem>
                          <Text
                            level={TextLevels.TWO}
                            typo={TypographyAlign.TEXT_CENTERED}
                            data-cy="boxBilanCarbone-mois"
                          >
                            {t('mois')}
                          </Text>
                        </RowItem>
                      </Rows>
                    </ColumnsItem>
                  </Columns>
                </Container>
              </ColumnsItem>
            </Columns>
          </RowItem>
          <RowItem>
            <Columns>
              <ColumnsItem size={12}>
                <Rows>
                  <RowItem className="is-fullwidth is-flex is-justified-center">
                    <Text
                      level={TextLevels.TWO}
                      className="has-text-justified"
                      data-cy="boxConsommationFlotte-description"
                    >
                      {t('description')}
                    </Text>
                  </RowItem>
                  <RowItem>
                    <Button
                      variant="TERTIARY"
                      className="is-fullwidth"
                      onClick={() => {
                        window.open(t('urlBilan'), '_blank');
                      }}
                    >
                      <Text level={TextLevels.TWO} data-cy="boxConsommationFlotte-bilan-btn">
                        {t('button')}
                      </Text>
                    </Button>
                  </RowItem>
                  <RowItem key={buttonNeutraliteCarbone.dataCy}>
                    {/* <Link
                      data-cy={buttonNeutraliteCarbone.dataCy}
                      className="has-text-secondary is-aligned-center"
                      href={buttonNeutraliteCarbone.routeRef?.href}
                      to={buttonNeutraliteCarbone.routeRef?.href}
                    >
                      <Text level={TextLevels.TWO} data-cy="boxConsommationFlotte-neutralite-btn">
                        {buttonNeutraliteCarbone.titre}
                      </Text>
                    </Link> */}
                    <ButtonNavigation
                      dataCy={buttonNeutraliteCarbone.dataCy}
                      titre={buttonNeutraliteCarbone.titre}
                      routeRef={buttonNeutraliteCarbone.routeRef}
                      iconName={buttonNeutraliteCarbone.iconName}
                    />
                  </RowItem>
                </Rows>
              </ColumnsItem>
            </Columns>
          </RowItem>
        </Rows>
      </BoxContent>
    </Box>
  );
};

export default BoxBilanCarbone;
